import "core-js/modules/es.array.join.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "城市"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.city_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "city_id", $$v);
      },
      expression: "searchForm.city_id"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _vm._l(_vm.cityList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.chCityName,
        value: item.id
      }
    });
  })], 2)], 1), _c("el-form-item", {
    attrs: {
      label: "城市档位"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.group,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "group", $$v);
      },
      expression: "searchForm.group"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _c("el-option", {
    attrs: {
      label: "A级",
      value: "A"
    }
  }), _c("el-option", {
    attrs: {
      label: "B级",
      value: "B"
    }
  }), _c("el-option", {
    attrs: {
      label: "C级",
      value: "C"
    }
  }), _c("el-option", {
    attrs: {
      label: "D级",
      value: "D"
    }
  }), _c("el-option", {
    attrs: {
      label: "无推广",
      value: "X"
    }
  })], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  }, [_c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.addDialog
    }
  }, [_vm._v("添加/修改配置")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "city_name",
      label: "城市"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "group",
      label: "城市档位"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "费用/RMB"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.cost.join("/")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "时长/h"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.duration.join("/")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "推广人数/人"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.promote_user_count.join("/")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateGroupDialog(scope.row);
            }
          }
        }, [_vm._v("修改档位")]), scope.row.groups.length ? _c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.previewDialog(scope.row);
            }
          }
        }, [_vm._v("预览描述")]) : _vm._e()];
      }
    }])
  })], 1), _c("el-dialog", {
    attrs: {
      title: "推广配置",
      width: "1000px",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form,
      "label-position": "left",
      "label-width": "68px"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "城市档位"
    }
  }, [_c("el-select", {
    on: {
      change: _vm.getPromoteConfig
    },
    model: {
      value: _vm.form.group,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "group", $$v);
      },
      expression: "form.group"
    }
  }, [_c("el-option", {
    attrs: {
      label: "A级",
      value: "A"
    }
  }), _c("el-option", {
    attrs: {
      label: "B级",
      value: "B"
    }
  }), _c("el-option", {
    attrs: {
      label: "C级",
      value: "C"
    }
  }), _c("el-option", {
    attrs: {
      label: "D级",
      value: "D"
    }
  })], 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "推广档位"
    }
  }, [_c("el-select", {
    on: {
      change: _vm.getPromoteConfig
    },
    model: {
      value: _vm.form.index,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "index", $$v);
      },
      expression: "form.index"
    }
  }, [_c("el-option", {
    attrs: {
      label: "1",
      value: "1"
    }
  }), _c("el-option", {
    attrs: {
      label: "2",
      value: "2"
    }
  }), _c("el-option", {
    attrs: {
      label: "3",
      value: "3"
    }
  }), _c("el-option", {
    attrs: {
      label: "4",
      value: "4"
    }
  })], 1)], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "费用"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.cost,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cost", $$v);
      },
      expression: "form.cost"
    }
  }, [_c("span", {
    attrs: {
      slot: "suffix"
    },
    slot: "suffix"
  }, [_vm._v("RMB")])])], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "浏览数"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.views,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "views", $$v);
      },
      expression: "form.views"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "时长"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.duration,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "duration", $$v);
      },
      expression: "form.duration"
    }
  }, [_c("span", {
    attrs: {
      slot: "suffix"
    },
    slot: "suffix"
  }, [_vm._v("H")])])], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "推送租客"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.promote_user_count,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "promote_user_count", $$v);
      },
      expression: "form.promote_user_count"
    }
  }, [_c("span", {
    attrs: {
      slot: "suffix"
    },
    slot: "suffix"
  }, [_vm._v("个")])])], 1)], 1)], 1), _c("el-row", {
    staticStyle: {
      margin: "0"
    },
    attrs: {
      gutter: 20
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "副标题"
    }
  }, [_c("el-col", {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      span: 8
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.title_zh,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title_zh", $$v);
      },
      expression: "form.title_zh"
    }
  }, [_c("span", {
    attrs: {
      slot: "suffix"
    },
    slot: "suffix"
  }, [_vm._v("中")])])], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.title_en,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title_en", $$v);
      },
      expression: "form.title_en"
    }
  }, [_c("span", {
    attrs: {
      slot: "suffix"
    },
    slot: "suffix"
  }, [_vm._v("英")])])], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.title_tw,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title_tw", $$v);
      },
      expression: "form.title_tw"
    }
  }, [_c("span", {
    attrs: {
      slot: "suffix"
    },
    slot: "suffix"
  }, [_vm._v("繁")])])], 1)], 1)], 1), _c("el-row", {
    staticStyle: {
      margin: "0"
    },
    attrs: {
      gutter: 20
    }
  }, [_c("el-form-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: "描述"
    }
  }, [_c("el-col", {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      span: 8
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: "6"
    },
    model: {
      value: _vm.form.desc_zh,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "desc_zh", $$v);
      },
      expression: "form.desc_zh"
    }
  })], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: "6"
    },
    model: {
      value: _vm.form.desc_en,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "desc_en", $$v);
      },
      expression: "form.desc_en"
    }
  })], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: "6"
    },
    model: {
      value: _vm.form.desc_tw,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "desc_tw", $$v);
      },
      expression: "form.desc_tw"
    }
  })], 1)], 1)], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer",
      align: "center"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.setPromoteConfig
    }
  }, [_vm._v("确认修改")]), _c("el-button", {
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取消操作")])], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "".concat(_vm.previewData.city_name, "-\u9884\u89C8\u63CF\u8FF0"),
      width: "600px",
      visible: _vm.previewDialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.previewDialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form,
      align: "center"
    }
  }, [_c("el-radio-group", {
    on: {
      change: _vm.previewRadioValueChange
    },
    model: {
      value: _vm.previewRadioValue,
      callback: function callback($$v) {
        _vm.previewRadioValue = $$v;
      },
      expression: "previewRadioValue"
    }
  }, _vm._l(_vm.previewData.groups, function (item) {
    return _c("el-radio-button", {
      key: item.token,
      attrs: {
        label: item.token
      }
    }, [_vm._v(_vm._s("\uFFE5".concat(item.cost)))]);
  }), 1), _c("p", [_vm._v("承诺增加浏览量：" + _vm._s(_vm.previewGroupData.views))]), _c("el-form-item", [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: "6"
    },
    model: {
      value: _vm.previewGroupData.desc_zh,
      callback: function callback($$v) {
        _vm.$set(_vm.previewGroupData, "desc_zh", $$v);
      },
      expression: "previewGroupData.desc_zh"
    }
  })], 1), _c("el-form-item", [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: "6"
    },
    model: {
      value: _vm.previewGroupData.desc_en,
      callback: function callback($$v) {
        _vm.$set(_vm.previewGroupData, "desc_en", $$v);
      },
      expression: "previewGroupData.desc_en"
    }
  })], 1), _c("el-form-item", {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: "6"
    },
    model: {
      value: _vm.previewGroupData.desc_tw,
      callback: function callback($$v) {
        _vm.$set(_vm.previewGroupData, "desc_tw", $$v);
      },
      expression: "previewGroupData.desc_tw"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer",
      align: "center"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.previewDialogVisible = false;
      }
    }
  }, [_vm._v("返回")])], 1)], 1), _c("el-dialog", {
    attrs: {
      width: "600px",
      visible: _vm.updateGroupDialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.updateGroupDialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      align: "center"
    }
  }, [_c("el-form-item", {
    attrs: {
      align: "center"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.updateGroupData.city_name) + " 所属城市档位 ")]), _c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    on: {
      change: _vm.selectCityGroup
    },
    model: {
      value: _vm.updateGroupData.group,
      callback: function callback($$v) {
        _vm.$set(_vm.updateGroupData, "group", $$v);
      },
      expression: "updateGroupData.group"
    }
  }, [_c("el-option", {
    attrs: {
      label: "A级",
      value: "A"
    }
  }), _c("el-option", {
    attrs: {
      label: "B级",
      value: "B"
    }
  }), _c("el-option", {
    attrs: {
      label: "C级",
      value: "C"
    }
  }), _c("el-option", {
    attrs: {
      label: "D级",
      value: "D"
    }
  }), _c("el-option", {
    attrs: {
      label: "无推广",
      value: "X"
    }
  })], 1)], 1), _vm.updateGroupData.groups && _vm.updateGroupData.groups.length ? _c("div", {
    staticClass: "group-detail"
  }, [_c("div", {
    staticClass: "header"
  }, [_c("span"), _vm._l(_vm.updateGroupData.groups, function (group) {
    return _c("span", {
      key: group.token
    }, [_vm._v(_vm._s(group.group + group.index))]);
  })], 2), _c("div", {
    staticClass: "row"
  }, [_c("span", [_vm._v("费用")]), _vm._l(_vm.updateGroupData.groups, function (group) {
    return _c("span", {
      key: group.token
    }, [_vm._v(_vm._s(group.cost))]);
  })], 2), _c("div", {
    staticClass: "row"
  }, [_c("span", [_vm._v("时长")]), _vm._l(_vm.updateGroupData.groups, function (group) {
    return _c("span", {
      key: group.token
    }, [_vm._v(_vm._s(group.duration) + "h")]);
  })], 2), _c("div", {
    staticClass: "row"
  }, [_c("span", [_vm._v("推送")]), _vm._l(_vm.updateGroupData.groups, function (group) {
    return _c("span", {
      key: group.token
    }, [_vm._v(_vm._s(group.promote_user_count) + "人")]);
  })], 2)]) : _vm._e()], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer",
      align: "center"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.updateCityGroup
    }
  }, [_vm._v("确认修改")]), _c("el-button", {
    on: {
      click: function click($event) {
        _vm.updateGroupDialogVisible = false;
      }
    }
  }, [_vm._v("取消操作")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };